
import axios from './mayiRequest'
/**
 * 获取城市ID，城市名称等数据
 * @param {Object} params 定位位置(非必传)
 */
export function geocoder(params) {
  return axios.post('/feapi/mayipromotionweb/mayibingo/h5/city/geocoder', {
    ...params
  })
}
